import { render, staticRenderFns } from "./CreateRemitterCreditComponent.vue?vue&type=template&id=199dab50"
import script from "./CreateRemitterCreditComponent.vue?vue&type=script&lang=js"
export * from "./CreateRemitterCreditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports